import React, { useState } from 'react';
import './styles.scss';
import { Text } from '../../text/Text.tsx';
import { formatContent } from '../../../utils/contentUtils.tsx';


type PopupProps = {
  title: string;
  content?: string;
  files?: string[];
  allowFull?: boolean;
  onClose: () => void;
};

export const Popup: React.FC<PopupProps> = ({ title, content, files, allowFull, onClose }) => {
  const [isFull, setIsFull] = useState(false);


  const showingFiles = () => {
    if (!files || files.length === 0) {
      return null;
    }

    return (
      <div className="popup-images">
        {files.map((file, index) => (
          <img key={index} src={file} alt={`${title} screenshot ${index + 1}`} className="popup-image" />
        ))}
      </div>
    )
  }

  return (
    <div
      className={`win98-popup ${isFull ? 'full-screen' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="popup-header">
        <Text variant="title3">{title}</Text>
        <div className="header-buttons">
          {allowFull && (
            <button className="maximize-btn" onClick={() => setIsFull(!isFull)}>
              {isFull ? '❐' : '□'}
            </button>
          )}
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
      </div>
      <div className="popup-body">
        {formatContent(content)}
        {showingFiles()}
      </div>
    </div>
  );
};
